import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import { MenuItem, MenuList, Paper, Stack, Typography } from "@mui/material";
import useUsers from "@/hooks/useUsers";
import { hasPermission } from "@/utils/functions/permission";
import { Permission } from "@/utils/constants/permission";


interface IRightClickPopup {
  userName: string;
  // eslint-disable-next-line no-unused-vars
  actions: Dic<(...args: unknown[]) => void>;
}

const RightClickPopup: React.FC<IRightClickPopup> = ({ userName, actions }) => {
  const { supervisor } = useUsers();
  const { deleteTrace, reverseTrace, saveTrace } = actions;

  return (
    <Stack width="100%">
      <Paper sx={{ p: 1 }}>
        <MenuList sx={{ padding: 0 }}>
          <Typography variant="subtitle1">Trace de : {userName}</Typography>
          <MenuItem onClick={deleteTrace} sx={{ p: 1 }}>
            <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
              <DeleteForeverIcon />
              <Typography>Retirer la trace</Typography>
            </Stack>
          </MenuItem>
          {supervisor != null && hasPermission(Permission.REVERSE_TRACE, supervisor) && (
            <MenuItem onClick={reverseTrace} sx={{ p: 1 }}>
              <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
                <SettingsBackupRestoreIcon />
                <Typography>Inverser la trace</Typography>
              </Stack>
            </MenuItem>
          )}
          {supervisor != null && hasPermission(Permission.SAVE_TRACE, supervisor) && (
            <MenuItem onClick={saveTrace} sx={{ p: 1 }}>
              <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
                <SaveAltIcon />
                <Typography>Sauvegarder</Typography>
              </Stack>
            </MenuItem>
          )}
        </MenuList>
      </Paper>
    </Stack>
  );
};

export default RightClickPopup;
